import authRoles from '@auth/authRoles';
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import LegacyRouteRedirect from '@/components/navigation/LegacyRouteRedirect';

const ClockWidget = lazy(() => import('./ClockWidget'));
const TimeEntriesWorkspace = lazy(() => import('./TimeEntriesWorkspace'));

/**
 * Time Tracking Routes
 *
 * Routes for employee time tracking functionality:
 * Canonical clock and entries pages. Legacy URLs retain filters and redirect
 * into the appropriate scope of the shared entries/scheduling workspace.
 */
const timeTrackingRoutes: FuseRouteItemType[] = [
	{
		path: 'time-tracking',
		children: [
			{
				index: true,
				auth: authRoles.staff,
				element: <LegacyRouteRedirect to="/time-tracking/clock" />
			},
			{
				path: 'clock',
				auth: authRoles.staff,
				element: <ClockWidget />
			},
			{
				path: 'entries',
				auth: authRoles.staff,
				element: <TimeEntriesWorkspace />
			},
			{
				path: 'my-entries',
				auth: authRoles.staff,
				element: (
					<LegacyRouteRedirect
						to="/time-tracking/entries"
						query={{ scope: 'mine' }}
					/>
				)
			},
			{
				path: 'my-schedule',
				element: (
					<LegacyRouteRedirect
						to="/staff-shifts"
						query={{ scope: 'mine' }}
					/>
				)
			},
			{
				path: 'schedule',
				element: (
					<LegacyRouteRedirect
						to="/staff-shifts"
						query={{ scope: 'teams', view: 'plan' }}
					/>
				)
			},
			{
				path: 'all-teams',
				auth: ['Admin', 'HR'],
				element: (
					<LegacyRouteRedirect
						to="/time-tracking/entries"
						query={{ scope: 'all' }}
					/>
				)
			}
		]
	}
];

export default timeTrackingRoutes;
